// extracted by mini-css-extract-plugin
export var black = "_44-6";
export var brand = "_44-1";
export var ddefault = "_44-0";
export var error = "_44-3";
export var gray = "_44-2";
export var highContrast = "_44-8";
export var outline = "_44-7";
export var success = "_44-5";
export var warning = "_44-4";